import {defineMessages} from 'react-intl'

/**
 * Catálogo de Tipos de deducción (`/user-deduction-type`).
 * Namespace `admin.deductionTypes.*` (Fase 1.11).
 *
 * Las etiquetas de `DEDUCTION_TYPE_OPTIONS` viven en `helpers/catalogMessages`
 * con el resto de enums del frontend (§10.6.A); aquí no se duplican.
 *
 * No se traducen: el nombre de un tipo de deducción (dato de BD) ni los
 * mensajes de error del backend.
 */
export const DEDUCTION_TYPE_MESSAGES = defineMessages({
  title: {id: 'admin.deductionTypes.title', defaultMessage: 'User Deduction Types'},
  empty: {id: 'admin.deductionTypes.empty', defaultMessage: 'There are no Deductions'},

  // Frase completa por variante: en español no basta con cambiar el verbo.
  modalAdd: {id: 'admin.deductionTypes.modal.add', defaultMessage: 'Add Deduction Type'},
  modalEdit: {id: 'admin.deductionTypes.modal.edit', defaultMessage: 'Edit Deduction Type'},

  deleteTitle: {
    id: 'admin.deductionTypes.delete.title',
    defaultMessage: 'Delete deduction type',
  },
  toastSaved: {
    id: 'admin.deductionTypes.toast.saved',
    defaultMessage: 'Commission rate updated successfully',
  },
  toastDeleted: {
    id: 'admin.deductionTypes.toast.deleted',
    defaultMessage: 'Commission Deduction Type deleted successfully',
  },
  somethingHappened: {
    id: 'common.error.somethingHappened',
    defaultMessage: 'Something happened',
  },

  createFailed: {id: 'admin.deductionTypes.error.createFailed', defaultMessage: 'Created failed'},
  updateFailed: {id: 'admin.deductionTypes.error.updateFailed', defaultMessage: 'Update failed'},

  // ── Reusadas ──
  name: {id: 'common.field.name', defaultMessage: 'Name'},
  type: {id: 'common.field.type', defaultMessage: 'Type'},
  value: {id: 'admin.organizations.th.value', defaultMessage: 'Value'},
  actions: {id: 'common.field.actions', defaultMessage: 'Actions'},
  saveChanges: {id: 'common.action.saveChanges', defaultMessage: 'Save changes'},
  cancel: {id: 'common.action.cancel', defaultMessage: 'Cancel'},
  save: {id: 'common.action.save', defaultMessage: 'Save'},
  delete: {id: 'common.action.delete', defaultMessage: 'Delete'},
  confirmDeleteRecord: {
    id: 'admin.oneUser.deductions.delete.body',
    defaultMessage: 'Are you sure you want to delete this record?',
  },
  errorWithMessage: {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
})
